export const SET_CHARTS = 'SET_CHARTS'
export const RESET_CHARTS = 'RESET_CHARTS'